<template>


	<div id="app-boards">


		<div id="app-boards-frm" v-if="params.mode === 'form'">
			<form-default></form-default>
		</div>


		<!-- 상세본문 -->
		<div id="app-boards-view" v-if="params.mode !== 'form'">
			<detail-default v-show="params.idx > 0 && params.idx !== undefined" :boardInfoVO="boardInfoVO" :boardVO="boardVO" @goForm="goForms" @goList="goList"></detail-default>
		</div>
		<!-- 상세본문 -->


		<!-- 목록 -->
		<div class="content board-list" v-if="params.mode === 'list'">
			<div class="container">

				<!-- 페이지 타이틀 -->
				<div class="page-title">
					<h2 class="tit">{{ boardInfoVO.boardName }}</h2>
				</div>


				<!-- 리스트 옵션 -->
				<div class="list-controls">

					<form @submit.prevent="doSearch">
						<!-- 탭 -->
						<div class="tab swiper-container" v-if="boardInfoVO.isCategory">
							<ul class="swiper-wrapper">

								<li class="swiper-slide" :class="{ 'active': params.cateCode === '' }">
									<a href="javascript:;" @click="setCateCode('')">전체</a>
								</li>
								<li class="swiper-slide" :class="{ 'active': params.cateCode === item.code }" v-for="(item, index) in boardInfoVO.cateList">
									<a href="javascript:;" @click="setCateCode( item.code )">{{ item.codeName }}</a>
								</li>

							</ul>
						</div>
						<!-- 검색 -->
						<div class="search">
							<!-- 버튼 -->
							<div class="btn-area text-right" v-if="isLogin() && boardInfoVO.isWrite">
								<button class="btn-submit" type="button" @click="goForms">등록</button>
							</div>
							<p class="total">총 <span>{{ boardCount }}</span>개의 게시물이 있습니다.</p>


							<div style="display: flex; flex-direction: row; justify-content: flex-end;">

								<div class="gui-form p-0" v-if="boardInfoVO.isStatus === true" style="border-top: 0; border-bottom: 0; ">
									<div class="row-box p-0">
										<div class="sel-inp-set">
											<select name="status-select-box" v-model="params.statusCode" style="margin : 0 14px; border-radius: 24px; min-width: 100px;">
												<option value="">전체</option>
												<option v-for="(item, index) in boardInfoVO.statusList" :value="item.code">{{ item.codeName }}</option>
											</select>
										</div>
									</div>
								</div>


								<div class="search-form">
									<input class="inp-search" id="" name="" type="text" placeholder="검색어를 입력하세요" v-model="params.searchText">
									<button class="btn-search" type="submit"></button>
								</div>
							</div>

						</div>
					</form>

					<board-sorter @doSort="doSort"></board-sorter>

				</div>


				<!-- 리스트 -->
				<list-webzine v-if="boardInfoVO.boardMode === 'webzine'" :board-info="boardInfoVO" :notice-list="noticeList" :board-list="boardList" @goBoardOne="goView"></list-webzine>
				<list-basic v-else-if="boardInfoVO.boardMode === 'basic'" :board-info="boardInfoVO" :notice-list="noticeList" :board-list="boardList" @goBoardOne="goView"></list-basic>
				<list-gallery v-else-if="boardInfoVO.boardMode === 'gallery'" :board-info="boardInfoVO" :notice-list="noticeList" :board-list="boardList" @goBoardOne="goView"></list-gallery>
				<list-faq v-else-if="boardInfoVO.boardMode === 'faq'" :board-info="boardInfoVO" :notice-list="noticeList" :board-list="boardList" @goBoardOne="goView"></list-faq>
				<list-classic v-else :notice-list="noticeList" :board-info="boardInfoVO" :board-list="boardList" @goBoardOne="goView"></list-classic>


				<!-- 버튼 -->
				<div class="btn-area" v-if="boardList.length < boardCount">
					<a href="javascript:;" class="btn-loadmore" @click="doLoadMore">LOAD MORE</a>
				</div>

				<!--				&lt;!&ndash; 버튼 &ndash;&gt;-->
				<!--				<div class="btn-area text-right" v-if="isLogin() && boardInfoVO.isWrite">-->
				<!--					<button class="btn-submit" type="button" @click="goForms">등록</button>-->
				<!--				</div>-->


			</div>
		</div>

	</div>


</template>

<script>

import ListClassic from "@/components/boards/lists/listClassic";
import DetailDefault from "@/components/boards/details/detailDefault";
import ListWebzine from "@/components/boards/lists/listWebzine";
import ListGallery from "@/components/boards/lists/listGallery";
import ListFaq from "@/components/boards/lists/listFaq";
import ListBasic from "@/components/boards/lists/listBasic";
import FormDefault from "@/components/boards/forms/formDefault";
import $ from "jquery";
import Swiper from "../../../public/ssflex/assets/js/swiper.min";
import BoardSorter from "@/components/boards/boardSorter.vue";


export default {
	name: "appBoards",
	components: {BoardSorter, FormDefault, ListBasic, ListFaq, ListGallery, ListWebzine, DetailDefault, ListClassic},
	props: {
		boardKey: String,
	},
	data() {

		let defBoardKey = this.boardKey
		if (defBoardKey == null) {
			defBoardKey = this.$route.params.boardKey
		}

		var params = this.pageUtils.Params()
		console.log(params)
		params.cateCode = this.webUtils.getParameter("cateCode");
		if (this.webUtils.getParameterInt("idx") > 0) {
			params.idx = this.webUtils.getParameterInt("idx");
		}

		if (!this.stringUtils.isEmpty(this.$route.query.writerKey)) {
			params.writerKey = this.$route.query.writerKey
		}

		return {

			params,

			defBoardKey,
			boardVO: {},

			boardCount: 0,
			boardInfoVO: {},
			noticeList: [],
			boardList: [],
			/*  statusCode : ""*/
		}
	},
	beforeCreate() {
	},
	async created() {

		this.boardInfoVO = await this.getBoardInfo(this.defBoardKey);
		this.params.size = this.boardInfoVO.pageCount
	},
	mounted() {
		console.log(this.$vnode.componentOptions.tag)
		if (location.hash) {
			let hash = location.hash.replace("#", "")
			if (hash !== 'loadMore') {
				this.webUtils.scroll(this, '#item-' + hash)
			}
		}

		if (this.mode !== "form" && this.params.idx > 0) {
			this.getBoardOne();
		}
		this.getBoardList();
	},
	updated() {
		/**
		 * common-ui.js 공통 부분 적용
		 * 카테고리 메뉴
		 */
		this.$nextTick(() => {
			// 서브 페이지 탭
			$(".list-controls .tab").each(function () {
				var tabnav = new Swiper($(this), {
					slidesPerView: "auto",
					spaceBetween: 24,
					freeMode: true,
					breakpoints: {
						767: {
							spaceBetween: 16,
						},
					},
				});
			});
		})
	},
	methods: {

		getBoardList() {

			this.$eventBus.$emit("startProgress")

			// this.params.mode = "list";
			var temp = JSON.parse(JSON.stringify(this.params))
			temp.boardKey = this.defBoardKey

			this.axiosCaller.get(this, this.APIs.BOARDS + "/getBoardList", temp, (res) => {
				var result = res.data
				if (result.status === "ok") {
					if (result.boardInfoVO.isNologin && !this.isLogin()) {
						this.requireLogin(this, false)
						this.$eventBus.$emit("doneProgress")
						return
					}
					this.boardCount = result.boardMap.count
					//this.boardList.push(...result.boardMap.list)
					this.boardList = result.boardMap.list
					this.noticeList = result.noticeMap.list

					if (location.hash) {
						let hash = location.hash.replace("#", "")
						if (hash === 'loadMore') {
							this.webUtils.scroll(
								this
								, '#item-' + this.boardList[(this.params.size) * (this.params.page * 1) - 1].idx
								, {
									behavior: "smooth"
									, block: "center"
								}
								, () => this.webUtils.removeHash()
								, () => {
									document.querySelector('.board-list').scrollIntoView({
										behavior: "smooth"
										, block: "end"
									})
									this.webUtils.removeHash()
								}
								, 1000
							)
						}
					}
				} else {
					this.swalUtils.gritter("Error", result.msg, "error")
				}
				this.$eventBus.$emit("doneProgress")
			})
		},


		doLoadMore() {

			this.resetBoardOne();
			this.params.page++;
			this.params.hash = 'loadMore'

			this.webUtils.goTo(this, this.params)
			// this.pageUtils.routerPush(this, this.params)
			/*this.$router.push({
			  query: this.params,
			}).catch(() => {})
			this.getBoardList();*/
		},


		setCateCode(_cateCode) {

			this.resetBoardOne();
			this.boardList = []
			this.params.page = 0
			this.params.size = this.boardInfoVO.pageCount
			this.params.cateCode = _cateCode;
			this.params.searchText = "";
			this.params.statusCode = "";

			this.pageUtils.routerPush(this, this.params)
			/*this.$router.push({
			  query: this.params,
			}).catch(() => {})
			this.getBoardList();*/
		},


		doSearch() {
			this.resetBoardOne();
			this.boardList = []
			this.params.page = 0
			this.params.size = this.boardInfoVO.pageCount

			this.pageUtils.routerPush(this, this.params)
			/*this.$router.push({
			  query: this.params,
			}).catch(() => {})
			this.getBoardList();*/
		},



		doSort ( _sort ) {
			this.params.sort = _sort;
			this.pageUtils.routerPush( this, this.params )
			// this.getMainList();
		},


		getBoardOne() {

			this.$eventBus.$emit("startProgress", 1)
			this.axiosCaller.get(this, this.APIs.BOARDS + "/getBoardOne/" + this.params.idx, {}, (res) => {
				var result = res.data
				this.boardVO = result.boardVO
				this.$eventBus.$emit("doneProgress", 1)

				this.$nextTick(() => {
					this.webUtils.scrollTo("#app")
				})
			})
		},


		resetBoardOne() {
			delete this.params.idx
			this.boardVO = {}
		},


		goList() {
			this.params.mode = "list"
			this.params.hash = this.params.idx

			this.resetBoardOne();
			this.webUtils.goTo(this, this.params)
		},


		goView(_idx) {
			// 기존 게시물 삭제
			this.resetBoardOne();
			this.params.idx = _idx
			this.params.boardKey = this.defBoardKey

			this.pageUtils.routerPush(this, this.params)
			/*this.$router.push({
			  query: this.params,
			}).catch(() => {})
			this.getBoardOne();*/
		},


		goForms(e, _idx = null) {

			/*var queryStr = "?mode=form"
			if ( _idx !== undefined && _idx > 0 ) {
			  queryStr += "&idx=" + _idx
			}
			location.href = location.pathname + queryStr*/
			this.params = {
				mode: 'form',
				boardKey: this.defBoardKey,
			}

			if (_idx != null) {
				this.params.idx = _idx
			}

			this.pageUtils.routerPush(this, this.params)
			/*this.$router.push({
			  query: this.params,
			}).catch(() => {})*/

			this.webUtils.scrollTo("#app-boards")

		},


	}
}
</script>

<style scoped>
.btn-submit {
	margin-bottom: 14px;
}
</style>
